module.exports = __webpack_public_path__ + "static/media/ffo_elterncafe.f4d04d66.jpg";